import React from "react";
import "../css/Slider.css";

import slider1 from '../image/Desarrollo_Medida.png'
import slider2 from '../image/Apps_Moviles.png'
import slider3 from '../image/Formacion_Digital.png'
import slider4 from '../image/Conexion_Remota.png'
import slider5 from '../image/Tranforma_Negocio.png'

const Slider = () => {
    const slides = [
        {
            img: slider1,
            active: true,
            alt: "Desarrollo a la medida",
            badgeIcon: "fa-solid fa-rocket",
            badge: "Soluciones tecnológicas",
            title1: "Desarrollo",
            title2: "A medida",
            text: "Creamos software moderno para impulsar y automatizar tu negocio.",
            cards: [
                { icon: "fa-solid fa-code", title: "Software", small: "A medida" },
                { icon: "fa-solid fa-mobile-screen-button", title: "Apps", small: "Web y móvil" },
                { icon: "fa-solid fa-shield-halved", title: "Seguridad", small: "Protección" },
            ],
        },
        {
            img: slider2,
            alt: "Apps móviles",
            badgeIcon: "fa-solid fa-mobile-screen-button",
            badge: "Aplicaciones móviles",
            title1: "Apps",
            title2: "Móviles",
            text: "Aplicaciones rápidas, modernas y adaptadas a tu empresa.",
            cards: [
                { icon: "fa-solid fa-bolt", title: "Rápidas", small: "Alto rendimiento" },
                { icon: "fa-solid fa-layer-group", title: "Multiapp", small: "Android & iOS" },
                { icon: "fa-solid fa-lock", title: "Seguras", small: "Protegidas" },
            ],
        },
        {
            img: slider3,
            alt: "Soporte tecnológico",
            badgeIcon: "fa-solid fa-headset",
            badge: "Soporte tecnológico",
            title1: "Soporte",
            title2: "TI 24/7",
            text: "Monitoreamos y protegemos tu infraestructura tecnológica.",
            cards: [
                { icon: "fa-solid fa-headset", title: "Atención", small: "Inmediata" },
                { icon: "fa-solid fa-network-wired", title: "Redes", small: "Servidores" },
                { icon: "fa-solid fa-shield-halved", title: "Protección", small: "Informática" },
            ],
        },
        {
            img: slider4,
            alt: "Formación digital",
            badgeIcon: "fa-solid fa-graduation-cap",
            badge: "Formación digital",
            title1: "Formación",
            title2: "Digital",
            text: "Capacítate con herramientas tecnológicas de alto nivel.",
            cards: [
                { icon: "fa-solid fa-code", title: "Código", small: "Práctico" },
                { icon: "fa-solid fa-chalkboard-user", title: "Cursos", small: "Guiados" },
                { icon: "fa-solid fa-certificate", title: "Perfil", small: "Profesional" },
            ],
        },
        {
            img: slider5,
            alt: "Conexión remota",
            badgeIcon: "fa-solid fa-globe",
            badge: "Conectividad remota",
            title1: "Conexión",
            title2: "Remota",
            text: "Acceso remoto seguro y soporte desde cualquier lugar.",
            cards: [
                { icon: "fa-solid fa-laptop-medical", title: "Soporte", small: "Remoto" },
                { icon: "fa-solid fa-cloud", title: "Cloud", small: "Seguro" },
                { icon: "fa-solid fa-lock", title: "Acceso", small: "Protegido" },
            ],
        },
    ];

    return (
        <section className="slider-section">
            <div
                id="carouselICS"
                className="carousel slide slider-ics"
                data-bs-ride="carousel"
            >
                <div className="carousel-inner">
                    {slides.map((slide, index) => (
                        <div
                            key={index}
                            className={`carousel-item slider-item ${slide.active ? "active" : ""}`}
                        >
                            <img
                                src={slide.img}
                                className="slider-img"
                                alt={slide.alt}
                            />

                            <div className="slider-overlay"></div>

                            <div className="slider-content">
                                <div className="slider-badge">
                                    <i className={slide.badgeIcon}></i>
                                    <span>{slide.badge}</span>
                                </div>

                                <h1 className="slider-title slider-title-dark">
                                    {slide.title1}
                                </h1>

                                <h1 className="slider-title slider-title-gradient">
                                    {slide.title2}
                                </h1>

                                <div className="slider-line"></div>

                                <p className="slider-text">
                                    {slide.text}
                                </p>

                                <div className="slider-cards">
                                    {slide.cards.map((card, i) => (
                                        <div className="slider-card" key={i}>
                                            <div className={`slider-card-icon icon-${i}`}>
                                                <i className={card.icon}></i>
                                            </div>

                                            <div className="slider-card-text">
                                                <h6>{card.title}</h6>
                                                <small>{card.small}</small>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <button
                    className="carousel-control-prev slider-control"
                    type="button"
                    data-bs-target="#carouselICS"
                    data-bs-slide="prev"
                >
                    <span className="carousel-control-prev-icon"></span>
                </button>

                <button
                    className="carousel-control-next slider-control"
                    type="button"
                    data-bs-target="#carouselICS"
                    data-bs-slide="next"
                >
                    <span className="carousel-control-next-icon"></span>
                </button>
            </div>
        </section>
    );
};

export default Slider;